import { useCallback, useEffect, useRef, useState } from 'react';

import companyEndpoints from '../../../../api/services/companyEndpoints';

export const useFetchPersonTypes = () => {
  const [loading, setLoading] = useState();
  const [personTypes, setPersonTypes] = useState([]);
  const isMounted = useRef(true);

  const fetchPersonTypes = useCallback(async () => {
    if (personTypes.length === 0) {
      try {
        const response = await companyEndpoints.getPersonTypes();
        if (response && response.status === 200) {
          if (isMounted.current) setPersonTypes(response.data);
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchPersonTypes().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchPersonTypes]);

  return {
    loading,
    personTypes,
  };
};